import SEOHelmet from '@/components/feature/SEOHelmet';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import HotMovies from './components/HotMovies';
import LatestArticles from './components/LatestArticles';
import StatsCTA from './components/StatsCTA';

export default function Home() {
  const seoData = {
    title: '777影院官网 - 7777影院、777777影院、77777影院入口 | 777影院首页网址导航',
    description: '777影院官方网站提供7777影院、777777影院、77777影院等数字变体统一入口，帮助用户快速进入官方首页，免费观看高清电影和电视剧全集。',
    keywords: '7777影院,777777影院,77777影院,7777777影院,777影院官网,777影院首页,777影院网址,777影院入口,数字变体,影视导航,免费在线观看',
    canonicalUrl: 'https://777cinema.com/',
    ogType: 'website',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '777影院',
      url: 'https://777cinema.com/',
      description: '777影院官方网站提供7777影院、777777影院、77777影院等数字变体统一入口，帮助用户快速进入官方首页，免费观看高清电影和电视剧全集。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://777cinema.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '777影院',
    url: 'https://777cinema.com/',
    description: '777影院官网提供高清电影和电视剧免费在线观看导航服务',
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://777cinema.com/',
      },
    ],
  };

  return (
    <>
      <SEOHelmet data={seoData} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />

      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />
        <CategoryGrid />
        <HotMovies />
        <LatestArticles />
        <StatsCTA />
      </main>

      <Footer />
    </>
  );
}